export default {
    agentInfo: state => state.agentInfo
};
